import MoveToInboxIcon from '@mui/icons-material/MoveToInbox'
import LocalGroceryStoreIcon from '@mui/icons-material/LocalGroceryStore'
import FactCheckIcon from '@mui/icons-material/FactCheck'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import AutoModeIcon from '@mui/icons-material/AutoMode'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import { SvgIconComponent } from '@mui/icons-material'

export const settingIconMap: Record<number, SvgIconComponent> = {
  1: MoveToInboxIcon,
  2: LocalGroceryStoreIcon,
  3: FactCheckIcon,
  4: LocalShippingIcon,
  5: AutoModeIcon
}

// Fallback si llega un typeSettingId no mapeado
export const getSettingIcon = (typeSettingId: number): SvgIconComponent =>
  settingIconMap[typeSettingId] ?? SettingsOutlinedIcon
